import React from "react";

import { Tooltip } from "components";

import { ReactComponent as WarningIcon } from "static/images/warning-icon.svg";
import styles from "./layout.module.scss";

type AriseSyncErrorProps = {
	isLoading: boolean;
	error: string;
	value?: string;
};

export const AriseSyncError = ({
	isLoading = false,
	error,
	value = "Affiliate sync failed",
}: AriseSyncErrorProps) => {
	return (
		!isLoading && (
			<Tooltip
				html={
					<div>
						<div>Failed to sync with ARISE:</div>
						{String(error ?? "")
							.split("\n")
							.map((line, index) => (
								<div key={index}>{line}</div>
							))}
					</div>
				}
			>
				<div className={styles.ariseSyncError}>
					<WarningIcon />
					<span>
						{value}: {error}
					</span>
				</div>
			</Tooltip>
		)
	);
};
